import React from 'react';
import { connect } from 'react-redux';
import { history } from 'redux/store';
import MenuItem from '@mui/material/MenuItem';
import KATlogo from 'static/images/mvp/KATlogo.png';
import USDTlogo from 'static/images/mvp/USDTlogo.png';
import PAXGlogo from 'static/images/mvp/PAXGlogo.png';
import BNBlogo from 'static/images/mvp/BNBLogo.png';
import ETHlogo from 'static/images/mvp/ETHLogo.png';
import POLlogo from 'static/images/mvp/POLlogo.png';
import { ethers } from 'ethers';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Box,
  Typography,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import CardPackagePayment from './CardPackagePayment';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import arrowBackIosIcon from 'static/images/mvp/solar_arrow-left-linear.png';
import loadingIcon from 'static/images/mvp/uiw_loading.png';
import successIcon from 'static/images/mvp/basil_check-solid.png';
import '../../custom-home.scss';
import './packages-payment.scss';
import ConfirmationDialog from './ConfirmationDialog';
import { Button } from '@kambria/kambria-lego';

import { Row } from 'antd';
import {
  getKatUSDTQuote,
  getTecdPackageById,
  getDaoDetailByCode,
  registerPackage,
  getWalletSessionByUserId,
} from 'redux/actions/mvp/tecd-package.action.js';
import { fetchUserMvp } from 'redux/actions/user.action';
import { I18n } from '../../../../../helpers/i18n';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paidCurrency: 'USDT', // giá trị mặc định
      title: '',
      priceUsdt: '',
      totalSession: '',
      totalDay: '',
      packageMainColor: '',
      packageSubColor: '',
      ServiceRevShareAddress: '',
      chainID: 1,
      infoNoti: '',
      infoStatus: '',
      showConfirmationDialog: false,
      confirmedQuote: 0,
      isButtonDisabled: false,
      isButtonDisplay: true,
      isDisplayPaymentArea: true,
      isDisplayPAXGPaymentArea: false,
    };
    this.ServiceRevShareABI = [
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_xdaoAddress",
            "type": "address"
          },
          {
            "internalType": "address[]",
            "name": "_currencyAddresses",
            "type": "address[]"
          },
          {
            "internalType": "uint8",
            "name": "_OrderHandlerPercentage",
            "type": "uint8"
          },
          {
            "internalType": "uint8",
            "name": "_LPHolderPercentage",
            "type": "uint8"
          },
          {
            "internalType": "address",
            "name": "_revenueCalculatorAddress",
            "type": "address"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint8",
            "name": "version",
            "type": "uint8"
          }
        ],
        "name": "Initialized",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "previousOwner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "previousAdminRole",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "newAdminRole",
            "type": "bytes32"
          }
        ],
        "name": "RoleAdminChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
          }
        ],
        "name": "RoleGranted",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
          }
        ],
        "name": "RoleRevoked",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "ADMIN_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "DEFAULT_ADMIN_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "LPHolderPercentage",
        "outputs": [
          {
            "internalType": "uint8",
            "name": "",
            "type": "uint8"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "OrderHandlerPercentage",
        "outputs": [
          {
            "internalType": "uint8",
            "name": "",
            "type": "uint8"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "TRANSACTION_IMPLEMENTOR_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "currencyAddress",
            "type": "address"
          }
        ],
        "name": "addCurrency",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint32",
            "name": "orderID",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "saleId",
            "type": "uint32"
          },
          {
            "internalType": "address",
            "name": "currencyAddress",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "subscriptionId",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "subscriptionName",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "paymentAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "endTimestamp",
            "type": "uint256"
          }
        ],
        "name": "buySubscription",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "_lpHolderAddresses",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "rateOfCurrenciesOnFirstToken",
            "type": "uint256[]"
          }
        ],
        "name": "calculateRevenueShares",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "orderID",
            "type": "uint256"
          }
        ],
        "name": "checkOrderExisted",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "claim",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "name": "claimerList",
        "outputs": [
          {
            "internalType": "address",
            "name": "wallet",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "withdrawableAmount",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "tokenAddress",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "name": "currencyAddresses",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          }
        ],
        "name": "getRoleAdmin",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "grantRole",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "hasRole",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "name": "orderHandlers",
        "outputs": [
          {
            "internalType": "address",
            "name": "partnerAddress",
            "type": "address"
          },
          {
            "internalType": "uint32",
            "name": "saleId",
            "type": "uint32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "owner",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "renounceRole",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "revenueCalculator",
        "outputs": [
          {
            "internalType": "contract RevenueCalculator",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "revokeRole",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes4",
            "name": "interfaceId",
            "type": "bytes4"
          }
        ],
        "name": "supportsInterface",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "_chanPartnerAddresses",
            "type": "address[]"
          },
          {
            "internalType": "uint32[]",
            "name": "saleIds",
            "type": "uint32[]"
          }
        ],
        "name": "updateOrderHandler",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "viewAllBuyTransactions",
        "outputs": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "buyer",
                "type": "address"
              },
              {
                "internalType": "uint32",
                "name": "orderID",
                "type": "uint32"
              },
              {
                "internalType": "uint32",
                "name": "saleId",
                "type": "uint32"
              },
              {
                "internalType": "address",
                "name": "currencyAddress",
                "type": "address"
              },
              {
                "internalType": "string",
                "name": "subscriptionId",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "subscriptionName",
                "type": "string"
              },
              {
                "internalType": "uint256",
                "name": "paymentAmount",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "timestamp",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "endTimestamp",
                "type": "uint256"
              },
              {
                "internalType": "bool",
                "name": "revenueShared",
                "type": "bool"
              }
            ],
            "internalType": "struct ServiceRevenueSharingV2.BuyTransaction[]",
            "name": "",
            "type": "tuple[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "viewAllrevenueCalculations",
        "outputs": [
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "wallet",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "withdrawableAmount",
                    "type": "uint256"
                  },
                  {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                  }
                ],
                "internalType": "struct ServiceRevenueSharingV2.Claimer[]",
                "name": "claimers",
                "type": "tuple[]"
              },
              {
                "internalType": "uint256",
                "name": "timestamp",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "totalSharesIn1stTokenWei",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "totalRevenueIn1stTokenWei",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "totalLPShareOn1stTokenWei",
                "type": "uint256"
              }
            ],
            "internalType": "struct ServiceRevenueSharingV2.RevenueCalculation[]",
            "name": "",
            "type": "tuple[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "xdaoAddress",
        "outputs": [
          {
            "internalType": "contract IDao",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      }
    ];
  }

  formatAmount = (price) => {
    if (price === null || price === undefined || isNaN(price)) {
      return '0';
    }
    const n = Number(price);
    if (!isFinite(n)) {
      return '0';
    }
    return n
      .toFixed(18)
      .replace(/\.0+$/, '')
      .replace(/(\.\d*[1-9])0+$/, '$1');
  }

  getQuote = async () => {
    const { getKatUSDTQuote } = this.props;
    const quote = await getKatUSDTQuote();
    if (quote && quote.success && quote.data) {
      this.setState({
        katQuote: quote.data.katToUSD || 0,
        usdtQuote: quote.data.usdtToUSD || 0,
        paxgQuote: quote.data.paxgToUSD || 0,
        bnbQuote: quote.data.bnbToUSD || 0,
        ethQuote: quote.data.ethToUSD || 0,
      });
    } else {
      console.error('Failed to fetch quotes:', quote?.error);
    }
  };

  componentWillUnmount() {
    // Dừng gọi hàm khi component bị gỡ bỏ
    clearInterval(this.quoteInterval);
  }

  async componentDidMount() {
    document.title = `TECD - ${I18n.t('tecd_slogan')}`;
    const {
      getKatUSDTQuote,
      getTecdPackageById,
      getDaoDetailByCode,
      registerPackage,
      getWalletSessionByUserId,
      match,
    } = this.props;
    const quote = await this.getQuote();
    try {
      const PAXGAddress = await revSharServiceContract.currencyAddresses(2);
      this.setState({ isDisplayPAXGPaymentArea: true });
    } catch (error) {
      this.setState({ isDisplayPAXGPaymentArea: false });
    }
    // Thiết lập interval để gọi hàm mỗi 10 giây
    this.quoteInterval = setInterval(() => {
      this.getQuote();
    }, 5000); // 10000 ms = 10 giây
    const { params } = match;
    const packageId = params.id;
    const packageResponse = await getTecdPackageById(packageId);
    const userDataId = JSON.parse(localStorage.getItem('user-info'))._id;
    const walletSession = await getWalletSessionByUserId(userDataId);
    // Kiểm tra nếu packageResponse có success bằng false

    if (packageResponse.success === false) {
      // Redirect đến trang 404
      history.push('/404');
      return;
    }
    const packageResponseData = packageResponse.data.data;
    // console.log("TECD")
    const daoInfo = await getDaoDetailByCode('TECD');
    // console.log("packageResponseData", packageResponseData.pricePaxg)
    this.setState({
      packageId: packageResponseData?._id ? packageResponseData?._id : packageResponseData.id,
      packageTitle: packageResponseData.title,
      priceOrigin: packageResponseData.priceOrigin || 0,
      priceKat: packageResponseData.priceKat || 0,
      priceUsdt: packageResponseData.priceUsdt || 0,
      // pricePaxg: packageResponseData.priceUsdt,
      totalSession: packageResponseData.totalSession,
      totalDay: packageResponseData.totalDay,
      packageMainColor: packageResponseData.packageMainColor,
      packageSubColor: packageResponseData.packageSubColor,
      saleOffPercentage: packageResponseData.saleOffPercentage,
      saleOffPercentageWithKATPayment: packageResponseData.saleOffPercentageWithKATPayment,
      chainID: daoInfo.data.data.chainId,
      daoInfo: daoInfo.data.data,
      ServiceRevShareAddress: daoInfo.data.data.serviceRevenueSharingAddress,
      walletSessionData: walletSession?.data?.data ?? null,
    });

    if (!this.state.ServiceRevShareAddress || !ethers.utils.isAddress(this.state.ServiceRevShareAddress)) {
      toast.info(I18n.t('payment_package_setup_error'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
    }
    if (walletSession.success === true) {
      //Tính toán start và endDate
      const today = new Date();
      const expiredDate = new Date(walletSession.data.data.expiredDate);
      const existSession = walletSession.data.data.existSession;
      // const existedSession = walletSession.data.data.session;
      let endDate;
      const hasActiveSubscription = expiredDate >= today && existSession > 0;
      if (hasActiveSubscription) {
        endDate = new Date(expiredDate.getTime() + this.state.totalDay * 24 * 60 * 60 * 1000); // Adding totalDay days to expiredDate
      } else {
        endDate = new Date(today.getTime() + this.state.totalDay * 24 * 60 * 60 * 1000); // Adding totalDay days to today
      }

      this.setState({
        startDate: today,
        endDate: endDate,
        currentPackageExpiredDate: hasActiveSubscription ? expiredDate : null,
      });
    } else {
      const today = new Date();

      this.setState({
        startDate: today,
        endDate: new Date(today.getTime() + this.state.totalDay * 24 * 60 * 60 * 1000), // Adding totalDay days to today
        currentPackageExpiredDate: null,
      });
    }
  }
  openConfirmationDialog = async () => {
    this.setState({
      showConfirmationDialog: true,
    });
  };
  connectMetamask = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.setState({ walletAddress: accounts[0] });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        this.signer = signer;
        // Lấy chain ID
        const network = await provider.getNetwork();
        const chainId = network.chainId;
        this.setState({ UserChainId: chainId });
        return true;
      } catch (error) {
        toast.info(I18n.t('payment_package_metamask_login'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
        return false;
      }
    } else {
      toast.info(I18n.t('payment_package_metamask_setup'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
      return false;
    }
  };
  handleChangeCurrency = (event) => {
    this.setState({
      paidCurrency: event.target.value,
      confirmedQuote: 0,
    });
  };

  refreshUserAfterPayment = async () => {
    const { fetchUserMvp } = this.props;
    if (!fetchUserMvp) {
      return;
    }
    try {
      await fetchUserMvp();
    } catch (e) {
      console.error('Failed to refresh user info after payment:', e);
    }
  };

  handlePayment = async () => {
    // Code to execute when the button is clicked

    const { registerPackage } = this.props;

    const isConnectMetamask = await this.connectMetamask();
    if (!isConnectMetamask) {
      return;
    }

    if (this.state.UserChainId.toString() !== this.state.chainID.toString()) {
      // Define a mapping of chain IDs to network names
      const networkNames = {
        1: 'Ethereum',
        56: 'Binance Smart Chain',
        137: 'Polygon',
      };

      // Get the network name based on this.state.chainID
      const networkName = networkNames[this.state.chainID.toString()] || 'Unknown Network';

      // Display the toast with the network name included
      toast.info(I18n.t('change_chain_network', {networkName, chainID: this.state.chainID}), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
      return;
    }

    this.setState({
      isButtonDisabled: true,
      isButtonDisplay: false,
    });
    // Define the arguments
    const KATABI = [
      { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
          { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
          { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'Approval',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
          { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleGranted',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleRevoked',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'from', type: 'address' },
          { indexed: true, internalType: 'address', name: 'to', type: 'address' },
          { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'Transfer',
        type: 'event',
      },
      {
        inputs: [],
        name: 'ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'MINTER_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'owner', type: 'address' },
          { internalType: 'address', name: 'spender', type: 'address' },
        ],
        name: 'allowance',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'burn',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'decimals',
        outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'subtractedValue', type: 'uint256' },
        ],
        name: 'decreaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getOwner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'addedValue', type: 'uint256' },
        ],
        name: 'increaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'mint',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'receiver', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'mintTo',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'recipient', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'sender', type: 'address' },
          { internalType: 'address', name: 'recipient', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
    ];

    const USDTABI = [
      { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
          { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
          { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'Approval',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
          { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleGranted',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleRevoked',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'from', type: 'address' },
          { indexed: true, internalType: 'address', name: 'to', type: 'address' },
          { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'Transfer',
        type: 'event',
      },
      {
        inputs: [],
        name: 'ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'MINTER_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'owner', type: 'address' },
          { internalType: 'address', name: 'spender', type: 'address' },
        ],
        name: 'allowance',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'burn',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'decimals',
        outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'subtractedValue', type: 'uint256' },
        ],
        name: 'decreaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getOwner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'addedValue', type: 'uint256' },
        ],
        name: 'increaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'mint',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'receiver', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'mintTo',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'recipient', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'sender', type: 'address' },
          { internalType: 'address', name: 'recipient', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
    ];
    const PAXGIMPLEMENTATIONABI = [
      { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
          { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
          { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'Approval',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: false, internalType: 'address', name: 'userAddress', type: 'address' },
          { indexed: false, internalType: 'address payable', name: 'relayerAddress', type: 'address' },
          { indexed: false, internalType: 'bytes', name: 'functionSignature', type: 'bytes' },
        ],
        name: 'MetaTransactionExecuted',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleGranted',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleRevoked',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'from', type: 'address' },
          { indexed: true, internalType: 'address', name: 'to', type: 'address' },
          { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'Transfer',
        type: 'event',
      },
      {
        inputs: [],
        name: 'CHILD_CHAIN_ID',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'CHILD_CHAIN_ID_BYTES',
        outputs: [{ internalType: 'bytes', name: '', type: 'bytes' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'DEPOSITOR_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'ERC712_VERSION',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'ROOT_CHAIN_ID',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'ROOT_CHAIN_ID_BYTES',
        outputs: [{ internalType: 'bytes', name: '', type: 'bytes' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'owner', type: 'address' },
          { internalType: 'address', name: 'spender', type: 'address' },
        ],
        name: 'allowance',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'decimals',
        outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'subtractedValue', type: 'uint256' },
        ],
        name: 'decreaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'user', type: 'address' },
          { internalType: 'bytes', name: 'depositData', type: 'bytes' },
        ],
        name: 'deposit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'userAddress', type: 'address' },
          { internalType: 'bytes', name: 'functionSignature', type: 'bytes' },
          { internalType: 'bytes32', name: 'sigR', type: 'bytes32' },
          { internalType: 'bytes32', name: 'sigS', type: 'bytes32' },
          { internalType: 'uint8', name: 'sigV', type: 'uint8' },
        ],
        name: 'executeMetaTransaction',
        outputs: [{ internalType: 'bytes', name: '', type: 'bytes' }],
        stateMutability: 'payable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getChainId',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'pure',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getDomainSeperator',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
        name: 'getNonce',
        outputs: [{ internalType: 'uint256', name: 'nonce', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'uint256', name: 'index', type: 'uint256' },
        ],
        name: 'getRoleMember',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleMemberCount',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'addedValue', type: 'uint256' },
        ],
        name: 'increaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'string', name: 'name_', type: 'string' },
          { internalType: 'string', name: 'symbol_', type: 'string' },
          { internalType: 'uint8', name: 'decimals_', type: 'uint8' },
          { internalType: 'address', name: 'childChainManager', type: 'address' },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'recipient', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'sender', type: 'address' },
          { internalType: 'address', name: 'recipient', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'withdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
    ];

    const revSharServiceContract = new ethers.Contract(
      this.state.ServiceRevShareAddress,
      this.ServiceRevShareABI,
      this.signer,
    );

    const orderID = Math.floor(Math.random() * 1000000000) + 1; // Sau này thay bằng logic tạo order ID (hiện kiểu dữ liệu đang là số nguyên)
    let paymentAmount;
    // console.log('this.state.daoInfo', this.state.daoInfo.subscriptionCompleteDurationInDay);
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const additionalSeconds = this.state.daoInfo.subscriptionCompleteDurationInDay * 24 * 60 * 60;
    const endTimeInSeconds = currentTimeInSeconds + additionalSeconds;

    // Sử dụng newTimeInSeconds ở đâu đó trong mã của bạn
    // console.log('endTimeInSeconds', currentTimeInSeconds, endTimeInSeconds);
    if (this.state.paidCurrency === 'KAT') {
      if (
        this.state.katQuote > this.state.confirmedQuote * 1.001 ||
        this.state.katQuote < this.state.confirmedQuote * 0.009
      ) {
        this.openConfirmationDialog();
        // console.log("confirmedQuote", this.state.confirmedQuote.toString())
        if (this.state.confirmedQuote !== 0) {
          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const KATAddress = await revSharServiceContract.currencyAddresses(1);
        const KATSmartContract = new ethers.Contract(KATAddress, KATABI, this.signer);
        const KATdecimal = await KATSmartContract.decimals();

        paymentAmount = this.state.priceKat / this.state.katQuote;
        // console.log("Raw payment amount:", paymentAmount);

        // Làm tròn số để tránh lỗi "fractional component exceeds decimals"
        const paymentAmountFixed = parseFloat(paymentAmount).toFixed(KATdecimal);
        // console.log("Fixed payment amount:", paymentAmountFixed);

        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountFixed, KATdecimal);
        // console.log("BigNumber payment amount:", paymentAmountBigNumber.toString());

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }

        // Get the current balance
        const currentBalance = await KATSmartContract.balanceOf(this.signer.getAddress());

        // Check if the current balance is less than the required payment amount
        if (currentBalance.lt(paymentAmountBigNumber)) {
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });

          console.error('Insufficient balance');
          return;
        }

        // Get the current allowance
        const currentAllowance = await KATSmartContract.allowance(
          this.signer.getAddress(),
          this.state.ServiceRevShareAddress,
        );

        // Check if the current allowance is less than the required payment amount
        if (currentAllowance.lt(paymentAmountBigNumber)) {
          // Increase the allowance by the difference between the payment amount and the current allowance
          // console.log("currentAllowance", currentAllowance);

          const increaseAmount = paymentAmountBigNumber.sub(currentAllowance);
          try {
            try {
              const increaseAllowanceResponse = await KATSmartContract.increaseAllowance(
                this.state.ServiceRevShareAddress,
                increaseAmount,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              await increaseAllowanceResponse.wait();
            } catch {
              toast.info(I18n.t('payment_package_need_to_increase_allowance'), {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: 'colored',
                className: 'toast-info-container',
              });
              this.setState({
                infoStatus: '',
                infoNoti: '',
                isButtonDisabled: false,
                isButtonDisplay: true,
              });

              return;
            }

            // Call the buySubscription method
            try {
              this.setState({ infoStatus: '' });

              this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
              const transactionResponse = await revSharServiceContract.buySubscription(
                orderID,
                0,
                KATAddress,
                this.state.packageId,
                this.state.packageTitle,
                paymentAmountBigNumber,
                endTimeInSeconds,
                { value: 0 } // Truyền giá trị BNB vào giao dịch

              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              const transactionReceipt = await transactionResponse.wait();
              // Tạo dataRequest sau khi thanh toán thành công

              const dataRequest = {
                // orderID: orderID,
                transactionId: transactionReceipt.transactionHash,
                // paidCurrency: this.state.paidCurrency,
                chainId: this.state.chainID,
                // packageTitle: this.state.packageTitle,
                // paymentAmount: paymentAmountBigNumber.toString(),
                // Thêm bất kỳ trường dữ liệu nào khác cần thiết cho hàm tiếp theo
              };
              // console.log("transactionReceipt", transactionReceipt);

              // Giả sử bạn có một hàm register cần dataRequest
              // console.log("dataRequest", dataRequest);
              try {
                const resgiterPackage = await registerPackage(dataRequest);
                this.setState({ infoStatus: 'loading' });
                this.setState({ infoNoti: I18n.t('payment_package_processing') });
                if (resgiterPackage.success === true) {
                  this.setState({ infoStatus: 'success' });
                  this.setState({
                    infoNoti: I18n.t('payment_package_payment_successful'),
                  });
                  await this.refreshUserAfterPayment();
                } else {
                  this.setState({ infoStatus: 'fail' });
                  this.setState({
                    infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                  });
                }
              } catch (error) {
                console.error(error);
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: I18n.t('payment_package_payment_failed') , error });
              }
            } catch (error) {
              this.setState({
                infoStatus: '',
                infoNoti: I18n.t('payment_package_payment_failed_try_again'),
                isButtonDisabled: false,
                isButtonDisplay: true,
              });
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          try {
            this.setState({ infoStatus: '' });

            this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
            const transactionResponse = await revSharServiceContract.buySubscription(
              orderID,
              0,
              KATAddress,
              this.state.packageId,
              this.state.packageTitle,
              paymentAmountBigNumber,
              endTimeInSeconds,
              { value: 0 } // Truyền giá trị BNB vào giao dịch

            );
            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: ' ' });
            const transactionReceipt = await transactionResponse.wait();

            // Tạo dataRequest sau khi thanh toán thành công
            const dataRequest = {
              transactionId: transactionReceipt.transactionHash,
              chainId: this.state.chainID,
            };

            // Giả sử bạn có một hàm register cần dataRequest
            // console.log("dataRequest", dataRequest);
            try {
              const resgiterPackage = await registerPackage(dataRequest);
              console.log('resgiterPackage', resgiterPackage, dataRequest);
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: I18n.t('payment_package_processing') });
              if (resgiterPackage.success === true) {
                this.setState({ infoStatus: 'success' });
                this.setState({
                  infoNoti: I18n.t('payment_package_payment_successful'),
                });
                await this.refreshUserAfterPayment();
              } else {
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}` });
              }
            } catch (error) {
              console.error(error);
              this.setState({ infoStatus: 'fail' });
              this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
          }
        }
      }
    } else if (this.state.paidCurrency === 'USDT') {
      if (
        this.state.usdtQuote > this.state.confirmedQuote * 1.001 ||
        this.state.usdtQuote < this.state.confirmedQuote * 0.009
      ) {
        // if (true) {
        this.openConfirmationDialog();
        if (this.state.confirmedQuote !== 0) {
          // console.log("confirmedQuote 123", this.state.confirmedQuote)

          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const USDTAddress = await revSharServiceContract.currencyAddresses(0);
        const USDTSmartContract = new ethers.Contract(USDTAddress, USDTABI, this.signer);
        const USDTdecimal = await USDTSmartContract.decimals();

        paymentAmount = this.state.priceUsdt / this.state.usdtQuote;
        // console.log("Raw payment amount:", paymentAmount);

        // Làm tròn số thập phân để tránh lỗi
        const paymentAmountFixed = parseFloat(paymentAmount).toFixed(USDTdecimal);
        // console.log("Fixed payment amount:", paymentAmountFixed);

        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountFixed, USDTdecimal);
        console.log("BigNumber payment amount:", paymentAmountBigNumber.toString());

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }

        // Get the current balance
        const currentBalance = await USDTSmartContract.balanceOf(this.state.walletAddress);
        // console.log("currentBalance", currentBalance.toString());
        // Check if the current balance is less than the required payment amount
        if (currentBalance.lt(paymentAmountBigNumber)) {
          // alert("Không đủ số dư để thực hiện giao dịch");
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error('Insufficient balance');
          return;
        }

        // Get the current allowance
        const currentAllowance = await USDTSmartContract.allowance(
          this.signer.getAddress(),
          this.state.ServiceRevShareAddress,
        );

        // Check if the current allowance is less than the required payment amount
        if (currentAllowance.lt(paymentAmountBigNumber)) {
          // Increase the allowance by the difference between the payment amount and the current allowance
          // console.log("currentAllowance", currentAllowance);
          const increaseAmount = paymentAmountBigNumber.sub(currentAllowance);
          let allowanceTxSuccess = false;
          try {
            try {
              const increaseAllowanceResponse = await USDTSmartContract.increaseAllowance(
                this.state.ServiceRevShareAddress,
                increaseAmount,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });

              await increaseAllowanceResponse.wait();
              allowanceTxSuccess = true;
            } catch (increaseErr) {
              console.warn('increaseAllowance failed, trying approve() fallback:', increaseErr?.message || increaseErr);
              const approveResponse = await USDTSmartContract.approve(
                this.state.ServiceRevShareAddress,
                paymentAmountBigNumber,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              await approveResponse.wait();
              allowanceTxSuccess = true;
            }

            if (!allowanceTxSuccess) {
              toast.info(I18n.t('payment_package_need_to_increase_allowance'), {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: 'colored',
                className: 'toast-info-container',
              });
              this.setState({
                infoStatus: '',
                infoNoti: '',
                isButtonDisabled: false,
                isButtonDisplay: true,
              });
              return;
            }

            try {
              this.setState({ infoStatus: '' });

              this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
              const transactionResponse = await revSharServiceContract.buySubscription(
                orderID,
                0,
                USDTAddress,
                this.state.packageId,
                this.state.packageTitle,
                paymentAmountBigNumber,
                endTimeInSeconds,
                { value: 0 } // Truyền giá trị BNB vào giao dịch
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              const transactionReceipt = await transactionResponse.wait();

              // Tạo dataRequest sau khi thanh toán thành công
              const dataRequest = {
                // orderID: orderID,
                transactionId: transactionReceipt.transactionHash,
                // transactionId: "0x03ed32d153dac98c23c8ec82d7cdd97cb9e5a5d44463d448dc97a82f9dff4ffe",
                // paidCurrency: this.state.paidCurrency,
                chainId: this.state.chainID,
                // packageTitle: this.state.packageTitle,
                // paymentAmount: paymentAmountBigNumber.toString(),
                // Thêm bất kỳ trường dữ liệu nào khác cần thiết cho hàm tiếp theo
              };

              // Giả sử bạn có một hàm register cần dataRequest
              // console.log("dataRequest", dataRequest);
              try {
                const resgiterPackage = await registerPackage(dataRequest);
                console.log('resgiterPackage', resgiterPackage, dataRequest);
                this.setState({ infoStatus: 'loading' });
                this.setState({ infoNoti: I18n.t('payment_package_processing') });
                if (resgiterPackage.success === true) {
                  this.setState({ infoStatus: 'success' });
                  this.setState({
                    infoNoti: I18n.t('payment_package_payment_successful'),
                  });
                  await this.refreshUserAfterPayment();
                } else {
                  this.setState({ infoStatus: 'fail' });
                  this.setState({
                    infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                  });
                }
              } catch (error) {
                console.error(error);
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
              }
            } catch (error) { }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
            console.error(error);
          }
          // Call the buySubscription method
        } else {
          try {
            this.setState({ infoStatus: '' });

            this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
            const transactionResponse = await revSharServiceContract.buySubscription(
              orderID,
              0,
              USDTAddress,
              this.state.packageId,
              this.state.packageTitle,
              paymentAmountBigNumber,
              endTimeInSeconds,
              { value: 0 } // Truyền giá trị BNB vào giao dịch
            );
            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: ' ' });

            const dataRequest = {
              transactionId: transactionReceipt.transactionHash,
              chainId: this.state.chainID,
            };

            try {
              const resgiterPackage = await registerPackage(dataRequest);
              console.log('resgiterPackage', resgiterPackage, dataRequest);
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: I18n.t('payment_package_processing') });
              if (resgiterPackage.success === true) {
                this.setState({ infoStatus: 'success' });
                this.setState({
                  infoNoti: I18n.t('payment_package_payment_successful'),
                });
                await this.refreshUserAfterPayment();
              } else {
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}` });
              }
            } catch (error) {
              console.error(error);
              this.setState({ infoStatus: 'fail' });
              this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
          }
        }
      }
    } else if (this.state.paidCurrency === 'PAXG') {
      if (
        this.state.paxgQuote > this.state.confirmedQuote * 1.001 ||
        this.state.paxgQuote < this.state.confirmedQuote * 0.009
      ) {
        // if (true) {
        this.openConfirmationDialog();
        if (this.state.confirmedQuote !== 0) {
          // console.log("confirmedQuote 123", this.state.confirmedQuote)

          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const PAXGAddress = await revSharServiceContract.currencyAddresses(2);
        const PAXGSmartContract = new ethers.Contract(PAXGAddress, PAXGIMPLEMENTATIONABI, this.signer);
        const PAXGdecimal = await PAXGSmartContract.decimals();
        paymentAmount = this.state.priceUsdt / this.state.paxgQuote;
        // console.log("payment amount", paymentAmount)
        // console.log("PAXGdecimal type:", typeof PAXGdecimal, "value:", PAXGdecimal);

        // const decimals = PAXGdecimal; // Đảm bảo PAXGdecimal có giá trị hợp lệ
        const paymentAmountFixed = parseFloat(paymentAmount).toFixed(PAXGdecimal); // Giới hạn số chữ số thập phân
        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountFixed, PAXGdecimal);

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }

        // const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmount.toString(), PAXGdecimal); // 18 is the number of decimal places for Ether
        // console.log('paymentAmountBigNumber', paymentAmountBigNumber)
        // Get the current balance
        const currentBalance = await PAXGSmartContract.balanceOf(this.state.walletAddress);
        // console.log("currentBalance", currentBalance.toString());
        // Check if the current balance is less than the required payment amount
        if (currentBalance.lt(paymentAmountBigNumber)) {
          // alert("Không đủ số dư để thực hiện giao dịch");
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error('Insufficient balance');
          return;
        }

        // Get the current allowance
        const currentAllowance = await PAXGSmartContract.allowance(
          this.signer.getAddress(),
          this.state.ServiceRevShareAddress,
        );

        // Check if the current allowance is less than the required payment amount
        if (currentAllowance.lt(paymentAmountBigNumber)) {
          // Increase the allowance by the difference between the payment amount and the current allowance
          // console.log("currentAllowance", currentAllowance);
          this.setState({ infoStatus: '' });
          this.setState({ infoNoti: I18n.t('payment_package_need_to_increase_allowance') });
          const increaseAmount = paymentAmountBigNumber.sub(currentAllowance);
          try {
            try {
              const increaseAllowanceResponse = await PAXGSmartContract.increaseAllowance(
                this.state.ServiceRevShareAddress,
                increaseAmount,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });

              await increaseAllowanceResponse.wait();
            } catch {
              toast.info(I18n.t('payment_package_need_to_increase_allowance'), {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: 'colored',
                className: 'toast-info-container',
              });
              this.setState({
                infoStatus: '',
                infoNoti: '',
                isButtonDisabled: false,
                isButtonDisplay: true,
              });
              return;
            }

            try {
              this.setState({ infoStatus: '' });

              this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
              const transactionResponse = await revSharServiceContract.buySubscription(
                orderID,
                0,
                PAXGAddress,
                this.state.packageId,
                this.state.packageTitle,
                paymentAmountBigNumber,
                endTimeInSeconds,
                { value: 0 } // Truyền giá trị BNB vào giao dịch
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              const transactionReceipt = await transactionResponse.wait();

              // Tạo dataRequest sau khi thanh toán thành công
              const dataRequest = {
                // orderID: orderID,
                transactionId: transactionReceipt.transactionHash,
                // transactionId: "0x03ed32d153dac98c23c8ec82d7cdd97cb9e5a5d44463d448dc97a82f9dff4ffe",
                // paidCurrency: this.state.paidCurrency,
                chainId: this.state.chainID,
                // packageTitle: this.state.packageTitle,
                // paymentAmount: paymentAmountBigNumber.toString(),
                // Thêm bất kỳ trường dữ liệu nào khác cần thiết cho hàm tiếp theo
              };

              // Giả sử bạn có một hàm register cần dataRequest
              // console.log("dataRequest", dataRequest);
              try {
                const resgiterPackage = await registerPackage(dataRequest);
                console.log('resgiterPackage', resgiterPackage, dataRequest);
                this.setState({ infoStatus: 'loading' });
                this.setState({ infoNoti: I18n.t('payment_package_processing') });
                if (resgiterPackage.success === true) {
                  this.setState({ infoStatus: 'success' });
                  this.setState({
                    infoNoti: I18n.t('payment_package_payment_successful'),
                  });
                  await this.refreshUserAfterPayment();
                } else {
                  this.setState({ infoStatus: 'fail' });
                  this.setState({
                    infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                  });
                }
              } catch (error) {
                console.error(error);
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
              }
            } catch (error) { }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
            console.error(error);
          }
          // Call the buySubscription method
        } else {
          try {
            this.setState({ infoStatus: '' });

            this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
            const transactionResponse = await revSharServiceContract.buySubscription(
              orderID,
              0,
              PAXGAddress,
              this.state.packageId,
              this.state.packageTitle,
              paymentAmountBigNumber,
              endTimeInSeconds,
              { value: 0 } // Truyền giá trị BNB vào giao dịch
            );
            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: ' ' });

            const dataRequest = {
              transactionId: transactionReceipt.transactionHash,
              chainId: this.state.chainID,
            };

            try {
              const resgiterPackage = await registerPackage(dataRequest);
              console.log('resgiterPackage', resgiterPackage, dataRequest);
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: I18n.t('payment_package_processing') });
              if (resgiterPackage.success === true) {
                this.setState({ infoStatus: 'success' });
                this.setState({
                  infoNoti: I18n.t('payment_package_payment_successful'),
                });
                await this.refreshUserAfterPayment();
              } else {
                this.setState({ infoStatus: 'fail' });
                this.setState({
                  infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                });
              }
            } catch (error) {
              console.error(error);
              this.setState({ infoStatus: 'fail' });
              this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
          }
        }
      }
    } else if (this.state.paidCurrency === 'BNB' || this.state.paidCurrency === 'ETH' || this.state.paidCurrency === 'POL') {
      if (
        this.state.bnbQuote > this.state.confirmedQuote * 1.001 ||
        this.state.bnbQuote < this.state.confirmedQuote * 0.009
      ) {
        // if (true) {
        this.openConfirmationDialog();
        if (this.state.confirmedQuote !== 0) {
          // console.log("confirmedQuote 123", this.state.confirmedQuote)

          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const BNB_ADDRESS = "0x0000000000000000000000000000000000000000";

        // Tính toán số lượng BNB cần thanh toán

        let paymentAmount = this.state.priceUsdt / this.state.bnbQuote;
        if (this.state.paidCurrency === 'ETH') {
          paymentAmount = this.state.priceUsdt / this.state.ethQuote;
        }
        const paymentAmountStr = Number(paymentAmount)
          .toFixed(18)
          .replace(/\.0+$/, '')
          .replace(/(\.\d*[1-9])0+$/, '$1');
        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountStr || '0', "ether");
        console.log('paymentAmount', paymentAmountStr)

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });

          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }
        // Lấy số dư hiện tại của BNB
        const currentBalance = await this.signer.getBalance();

        if (currentBalance.lt(paymentAmountBigNumber)) {
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });

          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error('Insufficient ', this.state.paidCurrency, ' balance');
          return;
        }

        try {
          this.setState({ infoStatus: '' });
          this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });

          // Gọi hàm buySubscription trên smart contract với giá trị BNB cần gửi
          const transactionResponse = await revSharServiceContract.buySubscription(
            orderID,
            0,
            BNB_ADDRESS, // Địa chỉ token là 0x00 để chỉ định dùng BNB
            this.state.packageId,
            this.state.packageTitle,
            paymentAmountBigNumber,
            endTimeInSeconds,
            { value: paymentAmountBigNumber } // Truyền giá trị BNB vào giao dịch
          );

          this.setState({ infoStatus: 'loading' });
          this.setState({ infoNoti: ' ' });

          const transactionReceipt = await transactionResponse.wait();
          console.log('transactionReceipt', transactionReceipt)
          // Gửi dữ liệu giao dịch đến hệ thống backend
          const dataRequest = {
            transactionId: transactionReceipt.transactionHash,
            chainId: this.state.chainID,
          };

          try {
            const registerPackageResponse = await registerPackage(dataRequest);
            console.log('registerPackage', registerPackageResponse, dataRequest);

            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: I18n.t('payment_package_processing') });

            if (registerPackageResponse.success) {
              this.setState({ infoStatus: 'success' });
              this.setState({
                infoNoti: I18n.t('payment_package_payment_successful'),
              });
              await this.refreshUserAfterPayment();
            } else {
              this.setState({ infoStatus: 'fail' });
              this.setState({
                infoNoti: `${I18n.t('payment_package_payment_failed')} ${registerPackageResponse.error}`,
              });
            }
          } catch (error) {
            console.error(error);
            this.setState({ infoStatus: 'fail' });
            this.setState({ infoNoti: `${I18n.t('payment_package_payment_failed')} ${error.message}` });
          }
        } catch (error) {
          this.setState({
            infoStatus: '',
            infoNoti: I18n.t('payment_package_payment_failed_try_again'),
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error(error);
        }
      }
    }
  };
  handlePaymentButtonClick = async () => {
    // this.setState({ showConfirmationDialog: true });
    if (!this.state.ServiceRevShareAddress || !ethers.utils.isAddress(this.state.ServiceRevShareAddress)) {
      toast.info(I18n.t('payment_package_setup_error'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
    } else {
      this.handlePayment();
    }
  };
  closeConfirmationDialog = (value) => {
    this.getQuote();
    this.setState({
      showConfirmationDialog: false,
      isButtonDisabled: false,
      isButtonDisplay: true,
    });

    if (value) {
      this.setState({
        isButtonDisplay: false,
        confirmedQuote: value,
      });
      this.handlePayment();
    }
  };
  render() {
    return (
      <div>
        {this.state.showConfirmationDialog && (
          <ConfirmationDialog
            paidCurrency={this.state.paidCurrency}
            lastKATQuote={this.state.katQuote}
            lastUSDTQuote={this.state.usdtQuote}
            paidAmountOnUSD={
              this.state.paidCurrency === 'KAT'
                ? (this.state.priceKat || 0)
                : this.state.paidCurrency === 'PAXG'
                  ? (this.state.priceUsdt || 0)
                  : (this.state.priceUsdt || 0)
            }
            packageId={this.state.packageId}
            packageTitle={this.state.packageTitle}
            chainID={this.state.chainID}
            serviceRevShareAddress={this.state.ServiceRevShareAddress}
            onClose={this.closeConfirmationDialog}
          />
        )}
        <div id="site_wrapper" className="payment-page-wrapper">
          <div className="site-upper">{this.props.header}</div>
          <main className="main-package-payment">
            <div className="container">
              <Box
                style={{
                  width: '100%',
                  height: 'auto',
                  gap: '64px',
                  alignItems: 'center',
                  marginTop: '20px',
                  marginBottom: '20px',
                }}
              >
                <img
                  src={arrowBackIosIcon}
                  alt="Arrow Back"
                  onClick={() => window.history.back()} // Add this line
                />
                <Typography
                  variant=""
                  className="your-package"
                  style={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    marginLeft: '280px', // Add a left margin to the text
                    textAlign: 'center', // This aligns the text to the left
                  }}
                >
                  {I18n.t('your_package')}
                </Typography>
              </Box>
              <CardPackagePayment
                title={this.state.packageTitle}
                priceKat={this.state.priceKat / this.state.katQuote}
                priceUsdt={this.state.priceUsdt / this.state.usdtQuote}
                // pricePaxg={(this.state.priceUsdt / this.state.paxgQuote).toFixed(6)}//giá PAXG thì phải tính theo USDT rồi chia ra
                totalSession={this.state.totalSession}
                totalDay={this.state.totalDay}
                packageMainColor={this.state.packageMainColor}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                currentPackageExpiredDate={this.state.currentPackageExpiredDate}
              ></CardPackagePayment>
            </div>
          </main>
          <div className="payment-area">
            {this.state.isButtonDisplay && (
              <Row className="rowHeight4">
                {' '}
                {'\u00A0'}
                <div className="smallBuy">{I18n.t('payment_method')}</div>
              </Row>
            )}

            {/* <Row className="rowHeight4"> {'\u00A0'} */}
            <div></div>
            {this.state.isButtonDisplay && (
              <div className="box1">
                {this.state.paidCurrency === 'KAT' ? (
                  <img style={{ width: '45px', height: '45px' }} src={KATlogo} />
                ) : this.state.paidCurrency === 'USDT' ? (
                  <img style={{ width: '45px', height: '45px' }} src={USDTlogo} />
                ) : this.state.paidCurrency === 'PAXG' ? (
                  <img style={{ width: '45px', height: '45px' }} src={PAXGlogo} />
                ) : this.state.paidCurrency === 'BNB' ? (
                  <img style={{ width: '45px', height: '45px' }} src={BNBlogo} />
                ) : this.state.paidCurrency === 'ETH' ? (
                  <img style={{ width: '45px', height: '45px' }} src={ETHlogo} />
                ) : this.state.paidCurrency === 'POL' ? (
                  <img style={{ width: '45px', height: '45px' }} src={POLlogo} />
                ) : null}
                <Box sx={{ maxWidth: 70 }} className="selectCurrency">
                  <FormControl fullWidth className="selectBox" variant="standard">
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.paidCurrency}
                      label={I18n.t('payment_method')}
                      onChange={this.handleChangeCurrency}
                      sx={{
                        '& .MuiSelect-icon': {
                          // color: 'white', // Change the color of the select icon to white
                        },
                      }}
                    >
                      <MenuItem value={'KAT'}>KAT</MenuItem>
                      <MenuItem value={'USDT'}>USDT</MenuItem>
                      {(this.state.chainID === '1' || this.state.chainID === '137') && (
                        <MenuItem value={'PAXG'}>PAXG</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '1') && (
                        <MenuItem value={'ETH'}>ETH</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '56') && (
                        <MenuItem value={'BNB'}>BNB</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '137') && (
                        <MenuItem value={'POL'}>POL</MenuItem>
                      )}{' '}
                    </Select>
                  </FormControl>
                </Box>
                <div className="paidAmount">
                  {this.state.paidCurrency === 'KAT'
                    ? this.formatAmount(this.state.priceKat / this.state.katQuote)
                    : this.state.paidCurrency === 'PAXG'
                      ? this.formatAmount(this.state.priceUsdt / this.state.paxgQuote)
                      : this.state.paidCurrency === 'BNB'
                        ? this.formatAmount(this.state.priceUsdt / this.state.bnbQuote)
                        : this.state.paidCurrency === 'POL'
                          ? this.formatAmount(this.state.priceUsdt / this.state.bnbQuote)
                          : this.state.paidCurrency === 'ETH'
                            ? this.formatAmount(this.state.priceUsdt / this.state.ethQuote)
                            : this.formatAmount(this.state.priceUsdt / this.state.usdtQuote)
                  }{' '}
                  {this.state.paidCurrency}

                </div>
              </div>
            )}

            {this.state.infoNoti !== '' && (
              <div className="info-area">
                {this.state.infoStatus === 'success' && (
                  <img style={{ width: '120px', height: '120px' }} src={successIcon} />
                )}
                {this.state.infoStatus === 'loading' && (
                  <img style={{ width: '80px', height: '80px' }} src={loadingIcon} />
                )}

                <Typography className="notice-infor">{this.state.infoNoti}</Typography>
              </div>
            )}
            {this.state.isButtonDisplay && (
              <Button
                className="button-payment"
                onClick={this.handlePaymentButtonClick}
                disabled={this.state.isButtonDisabled}
              >
                {I18n.t('payment')}
              </Button>
            )}
          </div>

          {this.props.footer}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  getKatUSDTQuote,
  getTecdPackageById,
  getDaoDetailByCode,
  registerPackage,
  getWalletSessionByUserId,
  fetchUserMvp,
};
export default withRouter(connect(null, mapDispatchToProps)(Payment));
